import { cancelableCallable } from "@/server/cancelableCallable";
import { instance } from "../api-instance";

export const ProductApi = {
  getCalculatorSettings(applicationId: string, useSmartCalculator: boolean) {
    return instance
      .post(`product/calculatorSettings`, {
        applicationId,
        useSmartCalculator,
      })
      .then((res) => res.data);
  },

  setCalculatorSettings: cancelableCallable(
    (controller, settings: unknown): Promise<unknown> =>
      instance
        .post(`application/selectProduct`, settings, {
          signal: controller.signal,
        })
        .then((res) => res?.data)
  ),

  getDefaultCalculatorSettings: cancelableCallable(
    (controller, data: unknown): Promise<unknown> =>
      instance
        .post(`product/getCalculatorDefault`, data, {
          signal: controller.signal,
        })
        .then((res) => res?.data)
  ),

  getCurrentSelectProductResult: cancelableCallable(
    (controller, settings: unknown) =>
      instance
        .post(`application/GetCurrentSelectProductResult`, settings, {
          signal: controller.signal,
        })
        .then((res) => res?.data)
  ),
};
